import { factory, Flex, AspectRatioKeeper, Image, Typography, DsmColor, omitText } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React, { isValidElement } from 'react';
import classes from './FeatureModalContentBlock.module.css.mjs';

const FeatureModalContentBlock = factory((props, ref) => {
  const { heading, copy, image, isFullWidth = true, className, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Flex, { direction: "column", ref, className: clsx(className, classes.modalBlockRoot, isFullWidth && classes.modalBlockFull), ...rest }, image && /* @__PURE__ */ React.createElement(AspectRatioKeeper, { aspectRatio: isFullWidth ? "2:1" : "1:1" }, /* @__PURE__ */ React.createElement(Image, { ...image })), (heading || copy) && /* @__PURE__ */ React.createElement(
    Flex,
    {
      direction: "column",
      style: { alignSelf: "center" },
      className: clsx(classes.modalBlockContent, isFullWidth && classes.modalBlockContentFull)
    },
    heading && /* @__PURE__ */ React.createElement(Typography, { component: heading.component || "h4", ...omitText(heading), size: "h5", textColor: DsmColor.ContentPrimary }, heading.text),
    copy && /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: isValidElement(copy.text) ? "div" : copy.component || "p",
        ...omitText(copy),
        size: "paragraph-medium",
        textColor: DsmColor.ContentSecondary
      },
      copy.text
    )
  ));
});

export { FeatureModalContentBlock };
